import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

import Typography from "@mui/material/Typography";

import { useStyles } from "./Label.styles";

const Label = ({ size, weight, color, children, ...rest }) => {
  const classes = useStyles({ color });
  return (
    <Typography
      {...rest}
      component="p"
      className={clsx(
        classes.base,
        classes[size],
        classes[weight],
        rest.className,
      )}
    >
      {children}
    </Typography>
  );
};

Label.propTypes = {
  size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
  weight: PropTypes.oneOf(["light", "regular", "semibold"]),
  color: PropTypes.oneOf(["text.primary", "text.secondary", "text.tertiary"]),
  children: PropTypes.node.isRequired,
};

Label.defaultProps = {
  size: "md",
  weight: "regular",
  color: "text.primary",
};

export default Label;
